
import NavBar from './Components/NavBar/NavBar';
import Header from './Components/Header/Header';
import WhySection from './Components/WhySection/WhySection';
import Article from './Components/ArticleCards/Article';
import Footer from './Components/Footer/Footer'
import React from 'react';

function App() {
  return (
    <React.Fragment>
    <NavBar></NavBar>
    <Header></Header>
    <main>
    <WhySection></WhySection>
    <Article></Article>
    </main>
    <Footer></Footer>
    </React.Fragment>

  );
}

export default App;
